import { createAction, props } from '@ngrx/store';

import { UserState } from '../states/user.state';

export const set = createAction('[User] set', props<{ payload: UserState }>());
